import React from 'react'
import { Head, Header, UpdateForm } from './components'

const UpdateGroup = () => {
	return (
		<div className='sm:p-6 p-3'>
			<Head />
			<Header />
			<UpdateForm />
		</div>
	)
}

export default UpdateGroup
